import { ArrowDownIcon, CloseIcon, WriteIcon } from '@/components/icons'
import { Box, Stack, Typography } from '@mui/material'

interface MenuHeaderProps {
  onClick?: (event: any) => void
  onBack?: (event: any) => void
}

const MenuHeader = ({ onClick, onBack }: MenuHeaderProps) => {
  return (
    <Stack
      sx={{ height: '48px' }}
    >
      <Stack
        sx={{ backgroundColor: '#FFFFFF', height: '48px', borderBottom: '1px solid #D7D7D7', }}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        p="18px 19px"
      >
        <Stack direction="row" pt="6px" >
          <Box color="#999999" onClick={onBack} sx={{ cursor: "pointer", p: "2px" }}>
            <CloseIcon />
          </Box>
          <Stack sx={{ ml: "15px" }}>
            <Stack direction="row">
              <Typography sx={{ color: "#004744", fontSize: "16px", fontWeight: "500", lineHeight: "115%" }}>
                Common Data
              </Typography>
              <Box sx={{ p: '2px' }}>
                <ArrowDownIcon />
              </Box>
            </Stack>

          </Stack>
        </Stack>
        <Stack direction="row" >
          <Typography sx={{ mr: "13px", color: "#747474", p: "2px" }}>Last saved: June 11, 11:02</Typography>
          <Stack direction="row" sx={{ color: "#004744", cursor: "pointer" }} onClick={onClick}>
            <Typography sx={{ mr: "6px", p: "2px" }}>
              Manual Input
            </Typography>
            <WriteIcon />
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  )
}

export default MenuHeader